import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetBankBookingsExportGroups = ({
  bankTransactionIds,
  exportAll,
  fetchPolicy = "network-only",
}: {
  bankTransactionIds: string[];
  exportAll: boolean;
  fetchPolicy?: "network-only";
}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    bankTransactionsExportGroups: Record<string, string[]>;
  }>(BANK_TRANSACTIONS_EXPORT_GROUPS_QUERY, {
    variables: { tenantId, entityIds: bankTransactionIds, exportAll },
    fetchPolicy,
  });

  return {
    bankTransactionsExportGroups:
      data?.bankTransactionsExportGroups?.groupedBankTransactions ?? {},
    hasMissingDates:
      data?.bankTransactionsExportGroups?.hasMissingDates ?? false,
    error,
    loading,
    refetch,
  };
};

export const BANK_TRANSACTIONS_EXPORT_GROUPS_QUERY = gql`
  query BankTransactionsExportGroups(
    $entityIds: [String]
    $tenantId: String
    $exportAll: Boolean
  ) {
    bankTransactionsExportGroups(
      tenantId: $tenantId
      exportAll: $exportAll
      entityIds: $entityIds
    )
  }
`;
